import React from 'react';
import './TestimonialsSection.css';

function TestimonialsSection() {
    const testimonials = [
        {
            text: 'Отличен продукт! Мъртвата ми тяга се подобри значително, защото вече не спирам заради хващането.',
            rating: 5,
            name: 'Иван П.'
        },
        {
            text: 'Гриповете са удобни и издръжливи. Използвам ги от 6 месеца при всяка тренировка за гръб.',
            rating: 5,
            name: 'Мария К.'
        },
        {
            text: 'Бърза доставка, качествен продукт. Препоръчвам на всеки, който тренира сериозно.',
            rating: 5,
            name: 'Димитър С.'
        }
    ];

    return (
        <section className="testimonials-section">
            <h2>Какво казват нашите клиенти</h2>
            <div className="testimonials-grid">
                {testimonials.map((t, i) => (
                    <div key={i} className="testimonial-card">
                        <div className="testimonial-stars">
                            {'★'.repeat(t.rating)}
                        </div>
                        <p className="testimonial-text">"{t.text}"</p>
                        <p className="testimonial-name">{t.name}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default TestimonialsSection;
